var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1175 -549)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1175 549)",
    fill: "rgba(255,255,255,0)",
    stroke: "#6a6a6a",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    x2: 11,
    transform: "translate(1181.5 561)",
    fill: "none",
    stroke: "#6a6a6a",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x2: 14.016,
    transform: "translate(1179.992 557)",
    fill: "none",
    stroke: "#6a6a6a",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x2: 7,
    transform: "translate(1183.5 565)",
    fill: "none",
    stroke: "#6a6a6a",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyFilter);
export default __webpack_public_path__ + "static/media/grey_filter.b93a0e127becb001c711e88d07f6547e.svg";
export { ForwardRef as ReactComponent };